
<template>
  <div class="centerNav">
      <div class="personal-left fl">
        <ul>
          <router-link :to="{name:'PersonCenter'}" tag="h5" style="cursor: pointer">個人中心</router-link>
        <div v-for="item in footerLIst">
          <h5>{{item.titles}}</h5>
          <li v-for="list in item.titleChild">
            <router-link :to="{name:list.src}" tag="a">{{list.name}}</router-link>
          </li>
        </div>
        </ul>
      </div>
  </div>
</template>

<script>
  //common.js
  import {ifSignIn} from '@/utils/common';
  export default {
    name: 'CenterNav',
    components:{

    },
    data () {
      return {
        footerLIst:[
          {
            titles:'訂單中心' ,
            titleChild:[
              {name:'我的訂單',src:'MyOrder'},
              {name:'我的收藏',src:'MyCollection'},
              {name:'我的評論',src:'MyComment'},
//              {name:'跟蹤包裹',src:'MyPackage'}
            ]
          },
          {
            titles:'資產中心' ,
            titleChild:[
//              {name:'賬戶充值',src:'AccountRecharge'},
//              {name:'充值明細',src:'RechargeDetailed'},
              {name:'賬戶明細',src:'AccountDetailed'},
              {name:'積分明細',src:'IntegralDetailed'},
              {name:'優惠券',src:'Coupons'},
            ]
          },
          {
            titles:'帳戶設置' ,
            titleChild:[
              {name:'實名認證',src:'RealName'},
              {name:'帳戶安全',src:'AccountSecurity'},
              {name:'收貨地址',src:'ReceivingAddress'}
            ]
          }

        ]
      }
    },
    created(){
      //判断是否登录
      ifSignIn(this, () =>{})
      window.scrollTo(0,0)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.centerNav{
    display: flex;
    justify-content: space-between;
    margin-bottom:40px;
    ul{
      h5{
        color: #535353;
        font-size: 18px;
        font-weight: bold;
        margin: 16px 0;
      }
      li{
        a{
          color: #898989;
          text-decoration: none;
          font-size: 16px;
          line-height: 32px;
          &:hover{
             color: #e52848;
           }
        }
      }
    }
  .router-link-active{
    color: #e52848;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personalPage/CenterNav.vue